<template>
  <div class="payment-receipt-create-top-grid">
    <PaymentReceiptCreateDocumentCustomerCard
      :text="text"
      :document-type-options="documentTypeOptions"
      :customer-options="customerOptions"
      :selected-customer="selectedCustomer"
      :contributor-options="contributorOptions"
      :selected-receiver="selectedReceiver"
      :tax-regime-options="taxRegimeOptions"
      :cfdi-use-options="cfdiUseOptions"
      :payment-method-type-options="paymentMethodTypeOptions"
      :payment-form-options="paymentFormOptions"
      :info="info"
      :currency="currency"
      :exchange-rate="exchangeRate"
      :customer-pending-amount="customerPendingAmount"
      @select-customer="$emit('select-customer', $event)"
      @select-receiver="$emit('select-receiver', $event)"
      @info-change="$emit('info-change', $event)"
      @update:currency="$emit('update:currency', $event)"
      @update:exchange-rate="$emit('update:exchange-rate', $event)"
      @edit-contributor="$emit('edit-contributor')"
    />

    <PaymentReceiptCreatePaymentInfoCard
      :text="text"
      :payments-text="paymentsText"
      :info="info"
      :payment-form-options="paymentFormOptions"
      :payment-account-options="paymentAccountOptions"
      :bank-details="bankDetails"
      :currency="currency"
      :voucher-type="info.voucherType"
      @info-change="$emit('info-change', $event)"
      @update:bank-details="$emit('update:bank-details', $event)"
    />
  </div>
</template>

<script>
import PaymentReceiptCreateDocumentCustomerCard from '@/components/paymentReceipts/create/PaymentReceiptCreateDocumentCustomerCard.vue';
import PaymentReceiptCreatePaymentInfoCard from '@/components/paymentReceipts/create/PaymentReceiptCreatePaymentInfoCard.vue';

export default {
  name: 'PaymentReceiptCreateTopSection',
  components: {
    PaymentReceiptCreateDocumentCustomerCard,
    PaymentReceiptCreatePaymentInfoCard,
  },
  props: {
    text: {
      type: Object,
      required: true,
    },
    paymentsText: {
      type: Object,
      required: true,
    },
    customerOptions: {
      type: Array,
      default: () => [],
    },
    selectedCustomer: {
      type: Object,
      default: null,
    },
    contributorOptions: {
      type: Array,
      default: () => [],
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    taxRegimeOptions: {
      type: Array,
      default: () => [],
    },
    cfdiUseOptions: {
      type: Array,
      default: () => [],
    },
    paymentMethodTypeOptions: {
      type: Array,
      default: () => [],
    },
    paymentFormOptions: {
      type: Array,
      default: () => [],
    },
    paymentAccountOptions: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    exchangeRate: {
      type: Number,
      default: 1,
    },
    customerPendingAmount: {
      type: Number,
      default: 0,
    },
    bankDetails: {
      type: Object,
      required: true,
    },
    documentTypeOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['select-customer', 'select-receiver', 'info-change', 'update:bank-details', 'update:currency', 'update:exchange-rate', 'edit-contributor'],
};
</script>

<style scoped>
.payment-receipt-create-top-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
}

.payment-receipt-create-top-grid > * {
  min-height: 260px;
}

@media (max-width: 1200px) {
  .payment-receipt-create-top-grid {
    grid-template-columns: 1fr;
  }

  .payment-receipt-create-top-grid > * {
    min-height: 0;
  }
}
</style>
